/**
 * Calculates the initial date range for OCPP logs.
 * Sets the start date to one week prior to the current date at 00:00:00,
 * and the end date to the current date at the current time.
 * @returns {{ startDate: string; endDate: string }} The initial date range containing formatted startDate and endDate strings
 */
const getInitialDateRange = (): { startDate: string; endDate: string } => {
  const now = new Date();
  const oneWeekAgo = new Date(now);
  oneWeekAgo.setDate(now.getDate() - 7);

  const startYear = oneWeekAgo.getFullYear();
  const startMonth = String(oneWeekAgo.getMonth() + 1).padStart(2, '0');
  const startDay = String(oneWeekAgo.getDate()).padStart(2, '0');
  const startDate = `${startYear}-${startMonth}-${startDay} 00:00:00`;

  const endYear = now.getFullYear();
  const endMonth = String(now.getMonth() + 1).padStart(2, '0');
  const endDay = String(now.getDate()).padStart(2, '0');
  const endHours = String(now.getHours()).padStart(2, '0');
  const endMinutes = String(now.getMinutes()).padStart(2, '0');
  const endSeconds = String(now.getSeconds()).padStart(2, '0');
  const endDate = `${endYear}-${endMonth}-${endDay} ${endHours}:${endMinutes}:${endSeconds}`;

  return {
    startDate,
    endDate,
  };
};

export default getInitialDateRange;
